import React from 'react';
import ImageUpload from '../../components/ReactImageUpload/imageUpload';

const imageUploader = (props) => {
    return  (
        <div >
            <ImageUpload defaultImage={props.defaultImage} fieldValues={props.fieldValues}  />
        </div>
    );
}

export default imageUploader;